import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'

export enum WorkflowTypeEnum {
    GROSSING_BIOPSIES = 'GROSSING_BIOPSIES',
    PROCESSING_CYTOLOGIES = 'PROCESSING_CYTOLOGIES'
}

export interface CommonSampleTypeResponse {
    id: number
    code: string
    description: string
    active: boolean
    workflow: WorkflowTypeEnum
}

export interface SampleTypeWithCaseTypesResponse extends CommonSampleTypeResponse {
    caseTypes: CommonCaseTypeResponse[]
}
